import type { DragEvent } from "react";
import type { LeadItem, LeadStatus, LeadStatusId } from "../types/lead.types";
import { LeadCard } from "./LeadCard";

type LeadsKanbanBoardProps = {
	leads: LeadItem[];
	statuses: LeadStatus[];
	draggingLeadId?: string;
	onDragStart: (leadId: string) => void;
	onDropLead: (leadId: string, statusId: LeadStatusId) => void;
	onAddLead: (statusId: LeadStatusId) => void;
	onOpenLead: (lead: LeadItem) => void;
	canAddLead?: boolean;
};

export function LeadsKanbanBoard({
	leads,
	statuses,
	draggingLeadId,
	onDragStart,
	onDropLead,
	onAddLead,
	onOpenLead,
	canAddLead = true,
}: LeadsKanbanBoardProps) {
	const handleDrop = (event: DragEvent<HTMLUListElement>, statusId: LeadStatusId) => {
		event.preventDefault();
		const droppedLeadId = event.dataTransfer.getData("text/plain");

		if (droppedLeadId) {
			onDropLead(droppedLeadId, statusId);
		}
	};

	return (
		<div className="crm-leads-board">
			{statuses.map((status) => {
				const statusLeads = leads.filter((lead) => lead.statusId === status.id);

				return (
					<section className="crm-lead-column" key={status.id}>
						<header className="crm-lead-column-head">
							<span style={{ background: status.color }} />
							<strong>{status.name}</strong>
							<em>{statusLeads.length}</em>
						</header>
						<ul
							aria-label={`${status.name} leadlari`}
							className="crm-lead-dropzone"
							onDragOver={(event) => event.preventDefault()}
							onDrop={(event) => handleDrop(event, status.id)}
						>
							{statusLeads.length > 0 ? (
								statusLeads.map((lead) => (
									<li
										className={draggingLeadId === lead.id ? "crm-lead-dragging" : undefined}
										key={lead.id}
									>
										<LeadCard lead={lead} onDragStart={onDragStart} onOpen={onOpenLead} />
									</li>
								))
							) : (
								<li className="crm-lead-empty">Lead yo'q</li>
							)}
						</ul>
						{canAddLead && (
							<button
								className="crm-lead-column-add"
								onClick={() => onAddLead(status.id)}
								type="button"
							>
								<span>+</span>
								Qo'shish
							</button>
						)}
					</section>
				);
			})}
		</div>
	);
}
